// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2z63a","bigColWidth":"Table_bigColWidth__1Q3ub","biggerColWidth":"Table_biggerColWidth__Wk5I3","row":"Table_row__3CsL8","col":"Table_col__3mKwu"};